import { z } from 'zod'

import { AuthorizationSchema } from '@mntn-dev/authorization-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { ProfileSchema } from './profile.ts'

export const PrincipalSchema = z.object({
  authz: AuthorizationSchema,
  profile: ProfileSchema,
})

export type Principal = ZodInfer<typeof PrincipalSchema>
